import React, { useEffect } from 'react';
import { useLocation, withRouter } from 'react-router-dom'

function ScrollToTop(props) {
  const { pathname } = useLocation();
  useEffect(() => {
    if(pathname.includes('advanced-search')) {
      if (pathname.split('/').length !== 3) {
        window.scrollTo(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return props.children
}
export default withRouter(ScrollToTop)
